import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanState extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanState';
}
